import React from "react";
import styled from "styled-components";
import "./customButton.scss";
import PropTypes from 'prop-types';

const CustomButtonStyle = styled.button`
 &:disabled {
    background-color: #394155;
    color: #8D95A8;
    border: 1px solid #444D63;
    border: none;
    opacity: 0.6;
    cursor: not-allowed;
  } `;

const CustomButton = React.forwardRef(({label = '', handleClick, ...props}, ref) => {
  const { disabled = false, buttonStyle = {}, children } = props;

  const generateButtonStyle = () => {
    switch (buttonStyle) {
      case "filled":
        return "filledButtonStyle";
      case "white":
        return "whiteButtonStyle";
      case "download":
        return "downloadButton";
      case "filter":
        return "filterButton";
      case "filterModal":
        return "filterModalButton";
      case "confirmbox-filled":
        return "confirmboxFilled";
      case "confirmbox-white":
        return "confirmboxWhite";
      case "preset-selected":
        return "presetSelected";
      case "preset-unselected":
        return "presetUnselected";
      case "rounded-icon":
        return "roundedIcon"
      case "dateRange-filled":
        return "dateRangeFilled";
      case "addColleagueFilled":
        return "addAColleagueFilled";
      case "idleTimer-filled":
        return "idleTimerFilled";
      case "idleTimer-white":
        return "idleTimerWhite"
      default:
        return "filledButtonStyle";
    }
  }

  const handleButtonClick = () => {
    handleClick();
  };

  const className = `customButton ${generateButtonStyle()}`;

  return (
      <CustomButtonStyle onClick={handleButtonClick} disabled={disabled} ref={ref}
      aria-label={label}
      className= {className}>
      {children && <span>{children}</span>} 
      {label}
      </CustomButtonStyle>
  );
});


CustomButton.propTypes = {
  label: PropTypes.string,                
  handleClick: PropTypes.func.isRequired, 
  disabled: PropTypes.bool,               
  buttonStyle: PropTypes.string,          
  children: PropTypes.node                
};

export default CustomButton;
